/* eslint-disable no-unused-vars */
/* ICONS */
import { MdEmail, MdOutlineInventory2 } from "react-icons/md";
import { IoHeadsetOutline } from "react-icons/io5";
import { FaRegMessage } from "react-icons/fa6";
import { FaCloudUploadAlt } from "react-icons/fa";

const navMenu = [
  {
    id: 1,
    link: "/contact-us",
    icon: IoHeadsetOutline,
    name: "Contact Us",
  },
  {
    id: 1,
    link: "/uploads",
    icon: FaCloudUploadAlt,
    name: "Uploaded designs",
  },
];

export default navMenu;
